import { render, staticRenderFns } from "./Removed.vue?vue&type=template&id=6041ff7b&scoped=true&"
import script from "./Removed.vue?vue&type=script&lang=js&"
export * from "./Removed.vue?vue&type=script&lang=js&"
import style0 from "./Removed.vue?vue&type=style&index=0&id=6041ff7b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6041ff7b",
  null
  
)

export default component.exports